// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__vvxhU","cancel":"Modal_cancel__eejr3","modal__content":"Modal_modal__content__n2kAo"};